import React from 'react'
import '../../styles/about-company.sass'
import file from '../../img/File icon.svg'
import { files } from '../files'

const AboutCompanyComponent = () => (
  <div className='about-company'>
      IT-company Overcom is a team of developers of integrated software for processing centers, loyalty systems, and integration services for fuel companies. We are experts in developing solutions using computer vision and machine learning technologies.    
    <div className='files' onClick={() => {
      window.open(`${files.about}`, '_blank')
    }}>
      <img src={file} alt='file-icon' /><p>Information about adding products to the software registry</p>
    </div>
  </div>
)

export default AboutCompanyComponent